import { Component } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { HorizontalMenuComponent } from '../../components/horizontal-menu/horizontal-menu.component';
import { VerticalMenuComponent } from '../../components/vertical-menu/vertical-menu.component';
import { MenuGroup, MenuItem } from '../../models/menu-item.model';
import { AuthService } from '../../services/auth.service';

type GuardWithMeta = ((...args: unknown[]) => unknown) & { __allowedGroups?: string[] };

interface IntranetBlock {
  title: string;
  groups: MenuGroup[];
}

@Component({
  selector: 'app-intranet-home',
  imports: [HorizontalMenuComponent, VerticalMenuComponent, RouterOutlet],
  templateUrl: './intranet-home.component.html',
  styleUrl: './intranet-home.component.scss'
})
export class IntranetHomeComponent {
  private readonly modeDemploiItems = [
    'vue générale',
    'gestion des stocks',
    'gestion client',
    'gestion des logistiques',
    'gestion des commandes',
    'gestion du séquençage',
    'gestion du pipe',
    'gestion des données',
    'gestion des rapports',
    'gestion des métadonnées',
    'liste automatisée des tâches'
  ];

  private readonly homeSidebarGroups: MenuGroup[] = [
    {
      label: 'Accueil',
      implemented: true,
      items: [
        { label: 'Accueil', href: '/intranet', implemented: true },
      ],
    },
  ];

  private readonly intranetBlocks: IntranetBlock[] = [
    {
      title: 'Gestion des stocks',
      groups: [
        { label: 'Classes composants', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-stocks/classes-composants/voir', implemented: true }, { label: 'Créer', href: '/intranet/gestion-stocks/classes-composants/creer', implemented: true }, { label: 'Modifier', href: '/intranet/gestion-stocks/classes-composants/modifier', implemented: true }, { label: 'Supprimer', href: '/intranet/gestion-stocks/classes-composants/supprimer', implemented: true } ] },
        { label: 'Composants', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-stocks/composants/voir', implemented: true }, { label: 'Créer', href: '/intranet/gestion-stocks/composants/creer', implemented: true }, { label: 'Modifier', href: '/intranet/gestion-stocks/composants/modifier', implemented: true } ] },
        { label: 'Nomenclatures', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-stocks/nomenclatures/voir', implemented: true }, { label: 'Créer', href: '/intranet/gestion-stocks/nomenclatures/creer', implemented: true }, { label: 'Modifier', href: '/intranet/gestion-stocks/nomenclatures/modifier', implemented: true } ] },
        { label: 'Capteurs fabriqués', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-stocks/capteurs/voir', implemented: true }, { label: 'Créer', href: '/intranet/gestion-stocks/capteurs/creer', implemented: true }, { label: 'Modifier', href: '/intranet/gestion-stocks/capteurs/modifier', implemented: true } ] },
        { label: 'Chimie', implemented: true, items: [
          { label: 'Voir', href: '/intranet/gestion-stocks/chimie/voir', implemented: true },
          { label: 'Créer', href: '/intranet/gestion-stocks/chimie/creer', implemented: true },
          { label: 'Modifier', href: '/intranet/gestion-stocks/chimie/modifier', implemented: true }
        ] } ,
        { label: 'Lots de cartouches', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-stocks/lots-cartouches/voir', implemented: true }, { label: 'Créer', href: '/intranet/gestion-stocks/lots-cartouches/creer', implemented: true }, { label: 'Modifier', href: '/intranet/gestion-stocks/lots-cartouches/modifier', implemented: true }, { label: 'Supprimer', href: '/intranet/gestion-stocks/lots-cartouches/supprimer', implemented: true } ] },
        { label: 'Cartouches', implemented: true, items: [
          { label: 'Voir', href: '/intranet/gestion-stocks/cartouches/voir', implemented: true },
          { label: 'Créer', href: '/intranet/gestion-stocks/cartouches/creer', implemented: true },
          { label: 'Modifier', href: '/intranet/gestion-stocks/cartouches/modifier', implemented: true },
          { label: 'Import Excel', href: '/intranet/gestion-stocks/cartouches/import-excel', implemented: true }
        ] },
        
      ]
    },
    {
      title: 'Lignes de commandes',
      groups: [
        {
          label: 'Lignes de commandes',
          implemented: true,
          items: [
            {
              label: 'Liste des lignes de commandes en cours de préparation',
              href: '/intranet/gestion-livraisons/lignes-en-preparation',
              implemented: true,
            },
          ],
        },
      ],
    },
    
    {
      title: 'Gestion client',
      groups: [
        { label: 'Contacts', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-clients/contacts/voir', implemented: true }, { label: 'Créer', href: '/intranet/gestion-clients/contacts/creer', implemented: true }, { label: 'Modifier', href: '/intranet/gestion-clients/contacts/modifier', implemented: true }, { label: 'Supprimer', href: '/intranet/gestion-clients/contacts/supprimer', implemented: true } ] },
        { label: 'Gestion des commandes et factures', implemented: true, items: [ { label: 'Liste', href: '/commandes', implemented: true }, { label: 'Créer', href: '/commandes/create', implemented: true }, { label: 'Modifier', href: '/commandes/edit', implemented: true } ] },
        { label: 'Gestion des abonnements', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-clients/abonnements', implemented: true } ] },
        { label: 'Rapports livrés', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-clients/rapports', implemented: true } ] }
      ]
    },
    {
      title: 'Gestion des logistiques',
      groups: [
        { label: 'Adresses', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-logistiques/adresses/voir', implemented: true }, { label: 'Créer', href: '/intranet/gestion-logistiques/adresses/creer', implemented: true }, { label: 'Compléter', href: '/intranet/gestion-logistiques/adresses/modifier', implemented: true } ] },
        { label: 'Numéros de suivi colis', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-logistiques/suivi-colis', implemented: true } ] },
        { label: 'Rendez-vous de retrait', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-logistiques/retrait', implemented: true } ] },
        { label: 'Génération d\'étiquettes', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-logistiques/etiquettes', implemented: true } ] },
        { label: 'Choix des amorces', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-logistiques/amorce', implemented: true } ] },
        { label: 'États: attente / expédition / déployé / analyse', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-logistiques/etats', implemented: true } ] },
        { label: 'Réservation de dates d\'analyses', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-logistiques/reservation', implemented: true } ] },
        { label: 'Vérifier les livraisons', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-logistiques/verifier-livraisons', implemented: true } ] },
        { label: 'Capteurs en cours de livraison', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-logistiques/capteurs-en-cours-livraison', implemented: true } ] },
        { label: 'Cartouches en cours de livraison', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-logistiques/cartouches-en-cours-livraison', implemented: true } ] }
      ]
    },
    {
      title: 'Gestion des commandes',
      groups: [
        { label: 'Commandes', implemented: true, items: [ { label: 'Liste', href: '/intranet/commandes/voir', implemented: true }, { label: 'Créer', href: '/intranet/commandes/creer', implemented: true }, { label: 'Compléter', href: '/intranet/commandes/modifier', implemented: true } ] }
      ]
    },
    {
      title: 'Gestion du séquençage',
      groups: [
        {
          label: 'Cibles biologiques',
          implemented: true,
          items: [
            { label: 'Créer', href: '/intranet/gestion-analyses/cibles/creer', implemented: true },
            { label: 'Éditer', href: '/intranet/gestion-analyses/cibles/modifier', implemented: true },
            { label: 'Voir/Supprimer', href: '/intranet/gestion-analyses/cibles/supprimer', implemented: true }
          ]
        },
        {
          label: 'Couples d\'amorces',
          implemented: true,
          items: [
            { label: 'Créer', href: '/intranet/gestion-analyses/couples-amorces/creer', implemented: true },
            { label: 'Éditer', href: '/intranet/gestion-analyses/couples-amorces/modifier', implemented: true },
            { label: 'Voir/Supprimer', href: '/intranet/gestion-analyses/couples-amorces/supprimer', implemented: true }
          ]
        },
        {
          label: 'Groupes d\'amorces',
          implemented: true,
          items: [
            { label: 'Créer', href: '/intranet/gestion-analyses/groupes-amorces/creer', implemented: true },
            { label: 'Éditer', href: '/intranet/gestion-analyses/groupes-amorces/modifier', implemented: true },
            { label: 'Voir/Supprimer', href: '/intranet/gestion-analyses/groupes-amorces/supprimer', implemented: true }
          ]
        },
        {
          label: 'Attribution',
          implemented: true,
          items: [
            { label: 'Attribuer', href: '/intranet/gestion-analyses/attribution/attribuer', implemented: true },
            { label: 'Voir', href: '/intranet/gestion-analyses/attribution/voir', implemented: true },
            { label: 'Export Excel', href: '/intranet/gestion-analyses/attribution/export-excel', implemented: true }
          ]
        },
        {
          label: 'Commandes de séquençage',
          implemented: true,
          items: [
            { label: 'Suivi des colis', href: '/intranet/gestion-analyses/commandes-sequencage/suivi-colis', implemented: true },
            { label: 'Liste des cartouches livrées', href: '/intranet/gestion-analyses/commandes-sequencage/cartouches-livrees', implemented: true },
            { label: 'Commandes de séquençage passées', href: '/intranet/gestion-analyses/commandes-sequencage/passees', implemented: true },
            { label: 'Cartouches commandées', href: '/intranet/gestion-analyses/commandes-sequencage/cartouches-commandees', implemented: true }
          ]
        }
      ]
    },
    {
      title: 'Gestion du pipe',
      groups: [
        {
          label: 'Antagène',
          implemented: true,
          items: [
            { label: 'Uploader des fichiers Antagène', href: '/intranet/gestion-pipe/uploader-antagene', implemented: true },
            { label: 'Lancer les analyses', href: '/intranet/gestion-pipe/consulter-antagene', implemented: true }
          ]
        }
      ]
    },
    {
      title: 'Gestion des données',
      groups: [
        { label: 'Résultat des analyses', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-donnees/resultat-analyses', implemented: true } ] },
        { label: 'Mise en base', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-donnees/mise-en-base', implemented: true } ] },
        { label: 'Crédibilité', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-donnees/credibilite', implemented: true } ] },
        { label: 'Export', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-donnees/export', implemented: true } ] },
        { label: 'Reversement GBIF', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-donnees/gbif', implemented: true } ] }
      ]
    },
    {
      title: 'Gestion des rapports',
      groups: [
        {
          label: 'Rapports internes',
          implemented: true,
          items: [
            { label: 'Tableau de bord (bientôt)', href: '/intranet/gestion-rapports/tableau-de-bord', implemented: true },
            { label: 'Export PDF (bientôt)', href: '/intranet/gestion-rapports/export-pdf', implemented: true }
          ]
        },
        {
          label: 'Rapports externes',
          implemented: true,
          items: [
            { label: 'Diffusion client (bientôt)', href: '/intranet/gestion-rapports/diffusion-client', implemented: true },
            { label: 'Archivage (bientôt)', href: '/intranet/gestion-rapports/archivage', implemented: true }
          ]
        }
      ]
    },
    
    {
      title: 'Gestion des métadonnées',
      groups: [
        { label: 'Suivis et modélisations', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-metadonnees/suivis', implemented: true } ] },
        { label: 'OpenWeatherMap', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-metadonnees/openweathermap', implemented: true } ] },
        { label: 'Relevés intermédiaires et relevé usine', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-metadonnees/releves', implemented: true } ] },
        { label: 'Date de pose et de relevé', implemented: true, items: [ { label: 'Voir', href: '/intranet/gestion-metadonnees/pose-releve', implemented: true } ] },
        { label: 'Position GPS', implemented: true, items: [ 
          { label: 'Voir', href: '/intranet/gestion-metadonnees/gps', implemented: true },
          { label: 'Export Excel', href: '/intranet/gestion-metadonnees/export-excel-capteurs', implemented: true }
        ] }
      ]
    },
    
    {
      title: 'Liste automatisée des tâches',
      groups: [
        {
          label: 'Tâches automatisées',
          implemented: true,
          items: [
            { label: 'Fichiers en attente d\'analyse', href: '/intranet/taches/fichiers-en-attente-analyse', implemented: true },
            { label: 'Cartouches livrées en attente d\'attribution', href: '/intranet/taches/cartouches-livrees-en-attente-attribution', implemented: true },
            { label: 'Cartouches attribuées en attente de séquençage', href: '/intranet/taches/cartouches-attribuees-en-attente-sequencage', implemented: true }
          ]
        },
        {
          label: 'Retards de livraison',
          implemented: true,
          items: [
            { label: 'Retard de livraison de capteurs', href: '/intranet/taches/retard-livraison-capteurs', implemented: true },
            { label: 'Retard de livraison de cartouches', href: '/intranet/taches/retard-livraison-cartouches', implemented: true }
          ]
        }
      ]
    }
  ];

  private routeAllowedGroupsMap = new Map<string, string[]>();
  private accessibleBlocks: IntranetBlock[] = [];
  protected topMenuItems: MenuItem[] = [];

  protected currentUrl = '';
  protected selectedTopMenuIndex = -1;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {
    this.initializeAccessModel();
    this.currentUrl = this.router.url;
    this.syncTopMenuFromUrl();

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects;
        this.syncTopMenuFromUrl();
      }
    });
  }

  protected get currentLeftTitle(): string {
    if (this.isHomeRoute) {
      return 'Accueil';
    }

    if (this.isModeDemploiRoute) {
      return this.modeDemploiTitle;
    }

    return this.accessibleBlocks[this.selectedBlockIndex]?.title ?? 'Articles';
  }

  protected get articleMenuGroups(): MenuGroup[] {
    if (this.isHomeRoute) {
      return this.homeSidebarGroups;
    }

    if (this.isModeDemploiRoute) {
      return this.buildModeDemploiSidebarGroups();
    }

    return this.accessibleBlocks[this.selectedBlockIndex]?.groups ?? [];
  }

  private get modeDemploiMenuIndex(): number {
    return this.topMenuItems.findIndex((item) => item.href === '/intranet/mode-demploi');
  }

  private get selectedBlockIndex(): number {
    if (this.selectedTopMenuIndex < 0) {
      return -1;
    }

    return this.selectedTopMenuIndex - 1;
  }

  protected get isHomeRoute(): boolean {
    return this.normalizeRoute(this.currentUrl) === '/intranet';
  }

  protected get isModeDemploiRoute(): boolean {
    return this.normalizeRoute(this.currentUrl).startsWith('/intranet/mode-demploi');
  }

  protected get modeDemploiTitle(): string {
    return 'Mode d\'emploi';
  }

  private buildModeDemploiSidebarGroups(): MenuGroup[] {
    const groups: MenuGroup[] = [];

    for (const nomItem of this.modeDemploiItems) {
      const displayName = nomItem
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

      groups.push({
        label: displayName,
        implemented: true,
        items: [
          {
            label: 'Voir',
            href: `/intranet/mode-demploi/${encodeURIComponent(nomItem)}/voir`,
            implemented: true,
          },
          {
            label: 'Éditer',
            href: `/intranet/mode-demploi/${encodeURIComponent(nomItem)}/editer`,
            implemented: true,
          },
        ],
      });
    }

    return groups;
  }

  protected selectTopMenu(index: number): void {
    if (this.topMenuItems[index]?.disabled) {
      return;
    }

    this.selectedTopMenuIndex = index;

    if (index === this.modeDemploiMenuIndex) {
      void this.router.navigateByUrl('/intranet/mode-demploi');
      return;
    }

    const firstEnabledHref = this.accessibleBlocks[this.selectedBlockIndex]?.groups
      .flatMap((group) => group.items)
      .find((item) => item.disabled !== true)?.href;

    if (firstEnabledHref && firstEnabledHref !== '#') {
      void this.router.navigateByUrl(firstEnabledHref);
    }
  }

  private syncTopMenuFromUrl(): void {
    if (this.isHomeRoute) {
      this.selectedTopMenuIndex = -1;
      return;
    }

    if (this.isModeDemploiRoute) {
      this.selectedTopMenuIndex = this.modeDemploiMenuIndex;
      return;
    }

    const prefixes = [
      '/intranet/gestion-stocks',
      '/intranet/gestion-livraisons',
      '/intranet/commandes',
      '/intranet/gestion-analyses',
      '/intranet/gestion-pipe',
      '/intranet/gestion-donnees',
      '/intranet/gestion-rapports',
      '/intranet/gestion-logistiques',
      '/intranet/gestion-metadonnees',
      '/intranet/gestion-clients',
      '/intranet/taches',
      '/commandes',
    ];

    for (const prefix of prefixes) {
      if (this.currentUrl.startsWith(prefix)) {
        const index = this.findTopMenuIndexByHrefPrefix(prefix);
        if (index >= 0) {
          this.selectedTopMenuIndex = index;
          return;
        }
      }
    }

    this.selectedTopMenuIndex = -1;
  }

  private findTopMenuIndexByHrefPrefix(prefix: string): number {
    const blockIndex = this.accessibleBlocks.findIndex((block) =>
      block.groups.some((group) =>
        group.items.some((item) => item.href.startsWith(prefix))
      )
    );

    if (blockIndex < 0) {
      return -1;
    }

    return blockIndex + 1;
  }

  protected logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  private initializeAccessModel(): void {
    this.routeAllowedGroupsMap = this.buildAllowedGroupsMap();

    this.accessibleBlocks = this.intranetBlocks.map((block) => {
      const mappedGroups = block.groups.map((group) => {
        const mappedItems = group.items.map((item) => ({
          ...item,
          disabled: !this.isItemAllowed(item.href),
        }));

        return {
          ...group,
          disabled: mappedItems.every((item) => item.disabled === true),
          items: mappedItems,
        };
      });

      return {
        ...block,
        groups: mappedGroups,
      };
    });

    this.topMenuItems = [
      {
        label: 'Mode d\'emploi',
        href: '/intranet/mode-demploi',
        implemented: true,
      },
      ...this.accessibleBlocks.map((block) => ({
        label: block.title,
        href: '#',
        implemented: true,
        disabled: block.groups.every((group) => group.disabled === true),
      })),
    ];
  }

  private isItemAllowed(href: string): boolean {
    const normalized = this.normalizeRoute(href);
    const allowedGroups = this.routeAllowedGroupsMap.get(normalized);
    if (!allowedGroups || allowedGroups.length === 0) {
      return true;
    }

    const userGroups = this.authService.getCurrentUser()?.groups ?? [];
    return allowedGroups.some((group) => userGroups.includes(group));
  }

  private buildAllowedGroupsMap(): Map<string, string[]> {
    const map = new Map<string, string[]>();
    const intranetRoute = this.router.config.find((route: any) => route.path === 'intranet');
    const children = intranetRoute?.children ?? [];

    for (const child of children) {
      if (!child.path) {
        continue;
      }

      const guard = (child.canActivate ?? []).find((candidate: unknown) => {
        const withMeta = candidate as GuardWithMeta;
        return Array.isArray(withMeta.__allowedGroups);
      }) as GuardWithMeta | undefined;

      if (!guard?.__allowedGroups || guard.__allowedGroups.length === 0) {
        continue;
      }

      map.set(this.normalizeRoute(`/intranet/${child.path}`), guard.__allowedGroups);
    }

    return map;
  }

  private normalizeRoute(path: string): string {
    return path.split('?')[0].replace(/\/:[^/]+/g, '').replace(/\/$/, '');
  }
}
